<template>
  <div>
    <px-view-header title="Departamentos" :breadcrumbs="breadcrumbs"/>

    <px-departemento-header @refresh="refresh" @change="onChangeFilter"/>
    <px-departamentos-list
      @update="refresh"
      :departamentos="departamentos"
      :loading="loading"
      @change="onChangeOptions"
      :options-list="optionsList"
    />
  </div>
</template>

<script>
import paginationMixin from '@/mixins/pagination-mixin';
import DepartamentoService from './departamento-service';
import DepartementoHeader from './DepartementoHeader.vue';
import DepartamentosList from './DepartamentosList.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      breadcrumbs: [
        { text: 'Marketplace' },
        { text: 'Departamentos' },
      ],
      searchText: null,
      departamentos: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 25,
        offset: 0,
        filter: '',
        sort: 'descricao',
      },
      loading: false,
      optionsList: {},
    };
  },
  methods: {
    refresh() {
      this.getDepartamentos();
    },
    onChangeFilter(filter) {
      this.listOptions.filter = filter;
      this.resetPage();
      this.getDepartamentos();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getDepartamentos();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getDepartamentos() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return DepartamentoService.list({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.departamentos = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxDepartementoHeader: DepartementoHeader,
    pxDepartamentosList: DepartamentosList,
  },
};
</script>
